<!-- app.vue -->
<script setup lang="ts">
useHead({
  htmlAttrs: { class: "scroll-smooth", lang: "en" },
  bodyAttrs: {
    class:
      "min-h-screen bg-slate-50 text-slate-900 antialiased selection:bg-slate-900 selection:text-white",
  },
  link: [{ rel: "icon", type: "image/ico", href: "/favicon.ico" }],
});
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
@import "~/assets/css/main.css";
</style>
